import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';

import { LanguageString } from 'containers/LanguageProvider';
import { NewButton as Button } from 'components/Button/NewButton';

import { cloneOrRender } from 'utilsTS/react';

import { TextInput, type TextInputProps } from '../TextInput';
import styles from './ClearableTextInput.module.scss';

export interface ClearableTextInputProps extends TextInputProps {
    showButton?: boolean;
    clearLabel?: string;
    input?: string | React.ComponentType | React.ReactNode;
    onClear?: () => void;
}

export const ClearableTextInput: React.FC<ClearableTextInputProps> = ({
    value,
    showButton = true,
    clearLabel,
    input = TextInput,
    onClear = noop,
    className,
    ...rest
}) => (
    <div className={cx('form-pseudo-control', styles.clearableInput, className)}>
        {cloneOrRender(input, { ...rest, value })}
        {showButton && value && (
            <Button
                variant={Button.VARIANT.TERTIARY}
                hiddenLabel={Button.HIDDEN_LABEL.ALWAYS}
                fullWidth={Button.FULL_WIDTH.NEVER}
                size={Button.SIZE.SMALL}
                icon={Button.ICON.ERROR}
                className={styles.clearButton}
                onClick={onClear}
            >
                <LanguageString name="common.clear" value={clearLabel} />
            </Button>
        )}
    </div>
);

ClearableTextInput.displayName = 'ClearableTextInput';
ClearableTextInput.propTypes = {
    ...TextInput.propTypes,
    showButton: PropTypes.bool,
    clearLabel: PropTypes.string,
    input: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node, PropTypes.func]),
    onChange: PropTypes.func,
    onClear: PropTypes.func,
};
